export const userActionTypes = {
  FETCH_USER_START: 'FETCH_USER_START',
  FETCH_USER_SUCCESS: 'FETCH_USER_SUCCESS',
  FETCH_USER_FAILED: 'FETCH_USER_FAILED',
  SET_CURRENT_USER: 'SET_CURRENT_USER',
  SET_TEMP_USER: 'SET_TEMP_USER',
};
